function customDomainProxy() {
    let url
    switch (location.hostname) {
        case 'control.us.axioms.io':
            url = 'proxy.us.axioms.io'
            break;

        case 'control.us.uat.axioms.io':
            url = 'proxy.us.uat.axioms.io'
            break;

        default:
            url = 'example.org'
            break;
    }
    return url
}

export default customDomainProxy;